/**
 * Collapsible Component
 * Simple collapsible section with smooth animations
 */

import { ChevronDown } from "lucide-react"
import { useState } from "react"

export interface CollapsibleProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  className?: string
}

export function Collapsible({
  title,
  children,
  defaultOpen = true,
  className = "",
}: CollapsibleProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div
      className={`border rounded-[10px] bg-card  border-[#FFFFFF1A] overflow-hidden ${className}`}
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-3.75 md:p-5 text-left hover:bg-muted/50 transition-colors"
        aria-expanded={isOpen}
      >
        <h3 className="text-sm font-semibold uppercase text-popover-foreground">{title}</h3>
        <ChevronDown
          className={`w-5 h-5 text-muted-foreground transition-transform duration-200 flex-shrink-0 ${
            isOpen ? "rotate-180" : ""
          }`}
          aria-hidden="true"
        />
      </button>
      <div
        className={`transition-all duration-200 ease-in-out ${
          isOpen ? "max-h-none opacity-100" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="px-5 pb-5">{children}</div>
      </div>
    </div>
  )
}
